import React from 'react';
import { ApiType } from '../types/ApiType';
import { ConfigClientType } from '../types/ConfigClientType';
import { getTranslation } from '../../constants/languages';
import { getPageExceptionTranslation } from '../../constants/siteIds';
import { PhoneNumbersPageExceptions } from './phonenumbers/page_exceptions';
import { PhoneNumbersRegions } from './phonenumbers/regions';

// Unfinished, have to double check that all the logic from phonenumber 2-3 is included

type PhoneNumberProps = {
  iimclient: ConfigClientType;
  api: ApiType;
};

export const NumberTemplate = ({ description, visual, link, id, onClick, buttonClass }) => (
  <>
    {description && (
      <div className={`if u-margin-top--16 button-label call-description${id}`}>
        {description}
      </div>
    )}
    <span className={`phoneNumber${id}`}>
      <a className={`if button ${buttonClass || 'secondary'} u-margin-top--16`}
        onClick={onClick}
        href={`tel:${link}`}
        id={`phoneNumber${id}`}
        role="button">
        {visual}
      </a>
    </span>
  </>
)

const getSegmentNumber = segment => {
  if (!segment) return null;
  return {
    callNumber1: {
      description: '',
      visual: segment.floater_call_phonelabel,
      link: segment.floater_call_phone,
    }
  };
};

const PhoneNumber = ({ iimclient }: PhoneNumberProps) => {
  const { lang, segment } = iimclient;
  const serviceContext = getPageExceptionTranslation(iimclient, PhoneNumbersPageExceptions) || getSegmentNumber(segment) || getTranslation(lang, PhoneNumbersRegions)

  const handleClick = ev => (window as any).NordicTracking.eventPhoneLink(
    false,
    (window as any).NordicTracking.PANELINFO_FUNCTION_NAME_PHONE,
    serviceContext.callNumber1.link()
  );

  const styles = {
    /*
    backgroundColor: callNumber.bgcolor ? callNumber.bgcolor : '',
    marginTop: callNumber.marginTop ? callNumber.marginTop : '',
    color: callNumber.color ? callNumber.color + ' !important' : '',
    */
  }

  return (
    <>
      { serviceContext.callNumber1 && <NumberTemplate {...serviceContext.callNumber1} id="1" onClick={handleClick} buttonClass={'primary'} /> }
      { serviceContext.callNumber2 && <NumberTemplate {...serviceContext.callNumber2} id="2" /> }
      { serviceContext.callNumber3 && <NumberTemplate {...serviceContext.callNumber3} id="3" /> }
    </>
  );
};

export default PhoneNumber;
